<template>
  <div class="splash">
    <a href="https://www.instagram.com/lisatellbe/" target="_blank"><p class="iglink-one">@lisatellbe</p></a>
    <a href="https://www.instagram.com/johnnyedlind/" target="_blank"><p class="iglink-two">@johnnyedlind</p></a>
    <div class='text'>
      <h1 class="grey">#MYHONOR</h1>
      <h1 class="white">COMMUNITY</h1>
      <!--<p>Vad är detta för hemsida - i en mening -copy.</p>-->
      <div class="button" v-on:click="scrollTo('community')">See Instagrams</div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
export default {
  name: 'splash',
  data () {
    return {
    }
  },
  methods: {
    scrollTo (divId) {
      $('html, body').animate({
        scrollTop: $('#' + divId).offset().top - 40
      }, 'slow')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .splash {
    height: 75vh;
    background-image: url('./../assets/img/new_banner-min.jpg');
    background-size: cover;
    background-position: center center;
    position: relative;
  }
  .text {
    padding-left: 2vw;
    padding-top: 24vh;
    width: 100%;
    box-sizing: border-box;
    max-width: 40vw;
  }
  h1.grey {
    font-size: 10vh;
    color: #fff;
  }
  h1.white {
    color: #808080;
  }
  p {
    color: #fff;
    max-width: 20vw;
  }
  .button {
    margin-top: 5vh;
    font-size: 3vh;
  }
  .iglink-one, .iglink-two {
    position: absolute;
    text-transform: uppercase;
    letter-spacing: 1px;
 }
  .iglink-one {
    bottom: 10px;
    left: 51%;
  }
  .iglink-two {
    bottom: 10px;
    right: 3%;
  }
  @media only screen and (max-width: 900px) {
    h1 {
      font-size: 10vh !important;
    }
    .text {
      max-width: 100vw;
      padding-left: 4vw;
      padding-top: 20vh;
    }
    .button {
      margin-top: 20px;
    }
    p {
      color: #fff;
      max-width: 70vw;
      font-size: 16px;
    }
    .splash {
      height: 73vh;
      background-image: url('./../assets/img/new_banner-min.jpg');
      background-size: cover;
      background-position: bottom center;
      background-repeat: no-repeat;
    }
    .iglink-one {
      bottom: 30px;
      left: 50%;
    }
    .iglink-two {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// Splash.vue?51ff13c4